var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('pre-base',{ref:"mybase",attrs:{"pre_data":_vm.init_data},on:{"base2-event":_vm.refresh_father}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{attrs:{"id":"notice"}},[_c('h5',[_vm._v("预支绑定使用说明:"),_c('br'),_c('span',[_vm._v("1、记录预支单都是给哪一个工资单使用啦,系统生成,添加无效,只能修改。")]),_c('br'),_c('span',[_vm._v("2、查询关键字:预支单号、预支月份、申请人、状态、工资单。")]),_c('br')])])])
}]

export { render, staticRenderFns }